// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-DocumentDropzone-module__root--1XH84","icon":"src-components-common-DocumentDropzone-module__icon--2rNHO"};